import React, { useRef, useState } from 'react';
import "./styles.scss";
import { useEffect } from 'react';
import DatePickerItem from './DatePickerItem';
export var TYPE;
(function (TYPE) {
    TYPE["DATE"] = "DATE";
    TYPE["MONTH"] = "MONTH";
    TYPE["YEAR"] = "YEAR";
})(TYPE || (TYPE = {}));
var DatePicker = function (props) {
    var FORMAT = 'DD/MM/YYYY';
    var daysGenerator = function () {
        var daysList = Array.from(Array(numberOfDays + 1).keys());
        daysList.shift();
        if (minDate && maxDate && minDate[2] === maxDate[2]) {
            return daysList.slice((minDate[2]) - 1, maxDate[2]);
        }
        else if (minDate && minDate[0] === selectedYear && minDate[1] === selectedMonth + ((minDate[1]))) {
            return daysList.slice((minDate[2]) - 1);
        }
        else if (maxDate && maxDate[0] === selectedYear && maxDate[1] === selectedMonth + 1) {
            return daysList.slice(0, maxDate[2]);
        }
        else {
            return daysList;
        }
    };
    var getFormattedDate = function () {
        var date;
        if (!props.preSelectedDate && !dateChanged) {
            return FORMAT;
        }
        else if (props.preSelectedDate && !dateChanged) {
            var temp = props.preSelectedDate.split("-");
            return [('0' + temp[2]).slice(-2), ('0' + temp[1]).slice(-2), temp[0]].join("-");
        }
        else if (minDate && minDate[0] === selectedYear) {
            date = new Date(selectedYear, selectedMonth + ((minDate[1]) - 1), selectedDay);
        }
        else
            date = new Date(selectedYear, selectedMonth, selectedDay);
        return "".concat(('0' + date.getDate()).slice(-2), "/").concat(('0' + date.getMonth()).slice(-2), "/").concat(date.getFullYear());
    };
    var minDate = props.min && props.min.split("-").map(function (n) { return parseInt(n, 10); });
    var maxDate = props.max && props.max.split("-").map(function (n) { return parseInt(n, 10); });
    var dateNumber = new Date().getDate();
    var monthNumber = new Date().getMonth();
    var yearNumber = maxDate ? Number(maxDate[0]) : new Date().getFullYear();
    var days = (new Date(yearNumber, monthNumber + 1, 0).getDate());
    var _a = useState(props.preSelectedDate ? (new Date(props.preSelectedDate).getFullYear()) : yearNumber), selectedYear = _a[0], setSelectedYear = _a[1];
    var _b = useState(props.preSelectedDate ? (new Date(props.preSelectedDate).getMonth()) : monthNumber), selectedMonth = _b[0], setSelectedMonth = _b[1];
    var _c = useState(props.preSelectedDate ? (new Date(props.preSelectedDate).getDate()) : dateNumber), selectedDay = _c[0], setSelectedDay = _c[1];
    var _d = useState(days), numberOfDays = _d[0], setNumberOfDays = _d[1];
    var _e = useState(false), toggleClassname = _e[0], setToggleClassname = _e[1];
    var _f = useState(daysGenerator()), datesList = _f[0], setDatesList = _f[1];
    var _g = useState(false), dateChanged = _g[0], setDateChanged = _g[1];
    var previousSelectedDateRef = useRef("");
    var _h = useState(getFormattedDate()), dateLabel = _h[0], setDateLabel = _h[1];
    useEffect(function () {
        if (minDate && minDate[0] === selectedYear && selectedMonth === 0) {
            setNumberOfDays((new Date(selectedYear, minDate[1], 0).getDate()));
        }
        else {
            setNumberOfDays((new Date(selectedYear, selectedMonth + 1, 0).getDate()));
        }
    }, [selectedMonth, selectedYear]);
    useEffect(function () {
        setDatesList(daysGenerator());
        (selectedDay > daysGenerator().length) && setSelectedDay(daysGenerator().length);
    }, [numberOfDays]);
    var yearGenerator = function () {
        var years = [];
        var yearNumbers = maxDate ? maxDate[0] : minDate ? yearNumber : yearNumber + 1;
        var yearLimit = minDate ? minDate[0] : yearNumber - 70;
        while (yearNumbers >= yearLimit) {
            years.push(yearNumbers--);
        }
        return years.reverse();
    };
    var monthGenerator = function () {
        var monthsList = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        if (maxDate && minDate && maxDate[0] === minDate[0] && minDate[1] === maxDate[1]) {
            return monthsList.slice((maxDate[1] - 1), maxDate[1]);
        }
        else if (maxDate && selectedYear === maxDate[0]) {
            return monthsList.slice(0, maxDate[1]);
        }
        else if (minDate && (selectedYear === minDate[0])) {
            return monthsList.slice(minDate[1] - 1);
        }
        else
            return monthsList;
    };
    var handleChange = function (type, value) {
        type === TYPE.YEAR ? setSelectedYear(value) : type === TYPE.MONTH ? setSelectedMonth(value) : setSelectedDay(value);
    };
    var setDateFormatter = function (month) {
        var date = new Date((new Date(selectedYear, selectedMonth + (month ? month : 0), selectedDay)).getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
        props.onDateClick(date);
        previousSelectedDateRef.current = date.split('-').reverse().join('-');
        setDateLabel(previousSelectedDateRef.current);
    };
    var onSetClick = function () {
        (minDate && minDate[0] === selectedYear) ? setDateFormatter(minDate[1] - 1) : setDateFormatter();
        setDateChanged(true);
        setToggleClassname(!toggleClassname);
    };
    var onCancelClick = function () {
        dateChanged && setDateLabel(previousSelectedDateRef.current);
        setToggleClassname(!toggleClassname);
    };
    return (React.createElement("div", { className: "date-wraper" },
        props.label && React.createElement("div", { className: "label" }, props.label),
        React.createElement("input", { type: "text", placeholder: FORMAT, className: "date-textbox", onClick: onCancelClick, onChange: function (event) { return event.currentTarget.value; }, value: dateLabel, readOnly: true }),
        React.createElement("div", { className: "datepicker-container".concat(toggleClassname ? "-show" : "") },
            React.createElement("div", { className: "Datepicker-title" }, " Set Date  "),
            React.createElement("div", { className: "Datepicker-Item" },
                React.createElement(DatePickerItem, { type: TYPE.DATE, selectedItem: props.preSelectedDate ? datesList.indexOf((new Date(props.preSelectedDate).getDate())) : minDate ? datesList.indexOf(minDate[2]) : maxDate ? datesList.indexOf(maxDate[2]) : datesList.indexOf(selectedDay), pickerItem: datesList, handleChange: handleChange }),
                React.createElement(DatePickerItem, { type: TYPE.MONTH, selectedItem: minDate && maxDate && minDate[1] === maxDate[1] ? 0 : props.preSelectedDate ? minDate && minDate[0] === selectedYear ? new Date(props.preSelectedDate).getMonth() - minDate[1] - 1 : new Date(props.preSelectedDate).getMonth() : maxDate ? (maxDate[1]) - 1 : selectedMonth, pickerItem: monthGenerator(), handleChange: handleChange }),
                React.createElement(DatePickerItem, { type: TYPE.YEAR, selectedItem: props.preSelectedDate ? yearGenerator().indexOf(new Date(props.preSelectedDate).getFullYear()) : yearGenerator().indexOf(yearNumber), pickerItem: yearGenerator(), handleChange: handleChange })),
            React.createElement("div", { className: "Date-picker-control" },
                React.createElement("div", { className: "datepicker-cancel", onClick: onCancelClick }, "Cancel"),
                React.createElement("div", { className: "datepicker-setter", onClick: onSetClick }, "Set")))));
};
export default DatePicker;
//# sourceMappingURL=index.js.map